module.exports = __webpack_public_path__ + "static/media/cort10.0f6c4a54.jpg";